import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { key: 0 }

import { ref, computed, reactive, onMounted } from 'vue'
import { message } from '@dc-platform/dc-components'
import Modal from '@/hooks/modalType'
import EditorTableText from '@/components/Editor/src/tableText.vue'
import CustomerAreaCascader from '@/components/CustomerAreaCascader/index.vue'
import ParamCodeCascader from '@/components/CosCascader/components/ParamCodeCascader.vue'
import { FbuFollowUpRecordParams, FbuFollowUpRecordItem } from '@/typings/api/followUpManage'
import { fbuFollowRecordsList, followRecordsDelete } from '@/api/overseasSales/followUpManage'
import { customerPhaseEnum, customerAllStatusEnum } from '@/views/overseasSales/commonEnum/dataConfig'
import { useRouter } from 'vue-router'
import { listByParamCodes } from '@/api/common'
import { useI18n } from 'vue-i18n'

const __default__ = {
  name: 'DcCosOFbuFollowUpRecord'
}


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const { t } = useI18n()
const tableRef = ref()
const router = useRouter()
const searchFrom = ref<FbuFollowUpRecordParams>({
  timeType: 0
})
const paramCodeData = reactive<{
  ofbu_follow_mode: []
  ofbu_follow_purpose: []
}>({
  ofbu_follow_mode: [], // 拜访方式
  ofbu_follow_purpose: [] // 访客目的
})
// 获取业务参数
const getByParamCodes = () => {
  listByParamCodes({
    appId: 'cos_ofbu',
    paramCodes: ['ofbu_follow_mode', 'ofbu_follow_purpose']
  }).then((res) => {
    if (res.code === 200) {
      Object.assign(paramCodeData, res.data)
    }
  })
}
const columns = computed(() => [
  {
    title: t('follow.customerName'),
    dataIndex: 'customerName',
    cosType: 'link',
    path: '/ofbu/followUpRecord/view',
    query: ['id'],
    fixed: 'left',
    width: 200
  },
  { title: t('follow.cosId'), dataIndex: 'followRefId' },
  { title: t('follow.customerNumber'), dataIndex: 'customerNumber' },
  { title: t('follow.planTitle'), dataIndex: 'planTitle' },
  { title: t('follow.purpose'), dataIndex: 'fbuPurpose', dicData: paramCodeData.ofbu_follow_purpose },
  {
    title: t('custom.customerPhaseEnum'),
    dataIndex: 'stage',
    dicData: [{ label: t('enum.customerPhase1'), value: 1 }, ...customerPhaseEnum]
  }, // 1-线索阶段, 2-潜在客户阶段, 3-成交客户阶段
  { title: t('custom.customerStatus'), dataIndex: 'followStatus', dicData: customerAllStatusEnum },
  { title: t('custom.level'), dataIndex: 'amountLevel' },
  { title: t('follow.dutyByName'), dataIndex: 'dutyByName' },
  { title: t('follow.fllowTime'), dataIndex: 'startTime', width: 350, sorter: true },
  { title: t('follow.processDetail'), dataIndex: 'process', width: 450 },
  { title: t('common.createByName'), dataIndex: 'createByName' },
  { title: t('common.createTime'), dataIndex: 'createTime', sorter: true, width: 160 },
  {
    title: t('common.action'),
    dataIndex: 'action',
    fixed: 'right',
    langWidth: {
      zh: 200,
      en: 220
    }
  }
])
const fetch = (params: FbuFollowUpRecordParams, callBack: (res: any) => void) => {
  fbuFollowRecordsList(params).then((res) => {
    callBack(res)
  })
}

const handleAdd = () => {
  router.push({
    path: '/ofbu/followUpRecord/add'
  })
}
const handleEdit = (record: FbuFollowUpRecordItem) => {
  router.push({
    path: '/ofbu/followUpRecord/edit',
    query: {
      id: record.id
    }
  })
}
const handleCommit = (record: FbuFollowUpRecordItem) => {
  router.push({
    path: '/ofbu/followUpRecord/commit',
    query: {
      id: record.id
    }
  })
}
const deleteRow = (record: FbuFollowUpRecordItem) => {
  Modal.delete({
    onOk() {
      followRecordsDelete(record.id).then(() => {
        message.success(t('tips.delSuccess'))
        tableRef.value.delFetch()
      })
    }
  })
}
// const success = (type = 'edit') => {
//   if (type === 'add') {
//     tableRef.value?.search()
//   } else {
//     tableRef.value?.fetch()
//   }
// }
onMounted(() => {
  getByParamCodes()
})

return (_ctx: any,_cache: any) => {
  const _component_a_input = _resolveComponent("a-input")!
  const _component_dc_form_item = _resolveComponent("dc-form-item")!
  const _component_user_select = _resolveComponent("user-select")!
  const _component_a_input_group = _resolveComponent("a-input-group")!
  const _component_a_select_option = _resolveComponent("a-select-option")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_CosRangePicker = _resolveComponent("CosRangePicker")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_ExportButton = _resolveComponent("ExportButton")!
  const _component_MoreButton = _resolveComponent("MoreButton")!
  const _component_cos_table = _resolveComponent("cos-table")!
  const _component_dc_layout_content = _resolveComponent("dc-layout-content")!
  const _component_dc_layout_main = _resolveComponent("dc-layout-main")!
  const _directive_permission = _resolveDirective("permission")!

  return (_openBlock(), _createBlock(_component_dc_layout_main, null, {
    default: _withCtx(() => [
      _createVNode(_component_dc_layout_content, null, {
        default: _withCtx(() => [
          _createVNode(_component_cos_table, {
            serial: "",
            columns: columns.value,
            search: searchFrom.value,
            "onUpdate:search": _cache[10] || (_cache[10] = ($event: any) => ((searchFrom).value = $event)),
            onFetch: fetch,
            ref_key: "tableRef",
            ref: tableRef,
            tableId: "DcCosOFbufollowUpRecord"
          }, {
            search: _withCtx(() => [
              _createVNode(_component_a_form, { model: searchFrom.value }, {
                default: _withCtx(() => [
                  _createVNode(_component_dc_form_item, {
                    name: "customerNumber",
                    label: _unref(t)('follow.customerNumber')
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_input, {
                        value: searchFrom.value.customerNumber,
                        "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((searchFrom.value.customerNumber) = $event)),
                        placeholder: _unref(t)('common.pleaseInput')
                      }, null, 8, ["value", "placeholder"])
                    ]),
                    _: 1
                  }, 8, ["label"]),
                  _createVNode(_component_dc_form_item, {
                    name: "customerName",
                    label: _unref(t)('follow.customerName')
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_input, {
                        value: searchFrom.value.customerName,
                        "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((searchFrom.value.customerName) = $event)),
                        placeholder: _unref(t)('common.pleaseInput')
                      }, null, 8, ["value", "placeholder"])
                    ]),
                    _: 1
                  }, 8, ["label"]),
                  _createVNode(_component_dc_form_item, {
                    label: _unref(t)('common.department')
                  }, {
                    default: _withCtx(() => [
                      _createVNode(CustomerAreaCascader, {
                        type: "search",
                        appId: "cos_ofbu",
                        ids: searchFrom.value.deptIdList,
                        "onUpdate:ids": _cache[2] || (_cache[2] = ($event: any) => ((searchFrom.value.deptIdList) = $event))
                      }, null, 8, ["ids"])
                    ]),
                    _: 1
                  }, 8, ["label"]),
                  _createVNode(_component_dc_form_item, {
                    name: "dutyBy",
                    label: _unref(t)('custom.followerName')
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_user_select, {
                        value: searchFrom.value.dutyBy,
                        "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((searchFrom.value.dutyBy) = $event))
                      }, null, 8, ["value"])
                    ]),
                    _: 1
                  }, 8, ["label"]),
                  _createVNode(_component_dc_form_item, {
                    label: _unref(t)('follow.channel')
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_input_group, { compact: "" }, {
                        default: _withCtx(() => [
                          _createVNode(ParamCodeCascader, {
                            type: "search",
                            ids: searchFrom.value.channelList,
                            "onUpdate:ids": _cache[4] || (_cache[4] = ($event: any) => ((searchFrom.value.channelList) = $event)),
                            appId: "cos_ofbu",
                            paramCode: "ofbu_source_channel",
                            style: {"width":"33%"},
                            placeholder: _unref(t)('common.pleaseSelect'),
                            allowClear: ""
                          }, null, 8, ["ids", "placeholder"]),
                          _createVNode(_component_a_input, {
                            value: searchFrom.value.channelExplain,
                            "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((searchFrom.value.channelExplain) = $event)),
                            placeholder: _unref(t)('common.pleaseInput'),
                            style: {"width":"67%"}
                          }, null, 8, ["value", "placeholder"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["label"]),
                  _createVNode(_component_dc_form_item, {
                    label: _unref(t)('follow.cosId')
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_input, {
                        value: searchFrom.value.followRefId,
                        "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((searchFrom.value.followRefId) = $event)),
                        placeholder: _unref(t)('common.pleaseInput')
                      }, null, 8, ["value", "placeholder"])
                    ]),
                    _: 1
                  }, 8, ["label"]),
                  _createVNode(_component_dc_form_item, {
                    label: _unref(t)('common.searchTime')
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_input_group, { compact: "" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_select, {
                            value: searchFrom.value.timeType,
                            "onUpdate:value": _cache[7] || (_cache[7] = ($event: any) => ((searchFrom.value.timeType) = $event)),
                            style: {"width":"33%"}
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_a_select_option, { value: 0 }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_unref(t)('common.createTime')), 1)
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_a_select_option, { value: 1 }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_unref(t)('follow.fllowTime')), 1)
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }, 8, ["value"]),
                          _createVNode(_component_CosRangePicker, {
                            isOutputBeijingTime: "",
                            startTime: searchFrom.value.startTime,
                            "onUpdate:startTime": _cache[8] || (_cache[8] = ($event: any) => ((searchFrom.value.startTime) = $event)),
                            endTime: searchFrom.value.endTime,
                            "onUpdate:endTime": _cache[9] || (_cache[9] = ($event: any) => ((searchFrom.value.endTime) = $event)),
                            style: {"width":"67%"}
                          }, null, 8, ["startTime", "endTime"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["label"])
                ]),
                _: 1
              }, 8, ["model"])
            ]),
            button: _withCtx(() => [
              _withDirectives((_openBlock(), _createBlock(_component_a_button, {
                type: "primary",
                onClick: handleAdd
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(t)('btn.add')), 1)
                ]),
                _: 1
              })), [
                [_directive_permission, 'ofbu_follow_add_btn']
              ]),
              _withDirectives((_openBlock(), _createBlock(_component_ExportButton, {
                appId: "cos_ofbu",
                taskType: "409",
                search: searchFrom.value
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(t)('btn.export')), 1)
                ]),
                _: 1
              }, 8, ["search"])), [
                [_directive_permission, 'ofbu_follow_export_btn']
              ])
            ]),
            bodyCell: _withCtx(({ column, record, text }) => [
              (column.dataIndex === 'startTime')
                ? (_openBlock(), _createElementBlock("p", _hoisted_1, _toDisplayString(text) + "~" + _toDisplayString(record.endTime), 1))
                : _createCommentVNode("", true),
              (column.dataIndex === 'process')
                ? (_openBlock(), _createBlock(EditorTableText, {
                    key: 1,
                    value: text
                  }, null, 8, ["value"]))
                : _createCommentVNode("", true),
              (column.dataIndex === 'action')
                ? (_openBlock(), _createBlock(_component_MoreButton, { key: 2 }, {
                    default: _withCtx(() => [
                      _withDirectives((_openBlock(), _createBlock(_component_a_button, {
                        type: "link",
                        onClick: ($event: any) => (handleEdit(record))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_unref(t)('btn.edit')), 1)
                        ]),
                        _: 2
                      }, 1032, ["onClick"])), [
                        [_directive_permission, 'ofbu_follow_edit_btn']
                      ]),
                      _withDirectives((_openBlock(), _createBlock(_component_a_button, {
                        type: "link",
                        onClick: ($event: any) => (deleteRow(record))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_unref(t)('btn.del')), 1)
                        ]),
                        _: 2
                      }, 1032, ["onClick"])), [
                        [_directive_permission, 'ofbu_follow_del_btn']
                      ]),
                      _withDirectives((_openBlock(), _createBlock(_component_a_button, {
                        type: "link",
                        onClick: ($event: any) => (handleCommit(record))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_unref(t)('btn.comment')), 1)
                        ]),
                        _: 2
                      }, 1032, ["onClick"])), [
                        [_directive_permission, 'ofbu_follow_comment_btn']
                      ])
                    ]),
                    _: 2
                  }, 1024))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["columns", "search"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})